<template>
  <div class="lmd-chat-section" id="lmdchat">
    <div class="clearfix">
      <div id="chatleft" class="lmd-sm-2">
        <div class="lmdchat-project-list">
          <h3>
            Nextcloud Conversations
            <span v-if="conversations.length > 0">({{ conversations.length }})</span>
          </h3>
          
          <!-- Loading State -->
          <div v-if="loading" class="loading-state">
            <p>Loading conversations...</p>
          </div>
          
          <!-- Error State -->
          <div v-if="error" class="error-state">
            <p style="color: red;">{{ error }}</p>
            <button @click="loadConversations" class="retry-btn">Retry</button>
          </div>
          
          <!-- Conversations List -->
          <div v-if="!loading && !error" class="chatlmd-pro-list conversations-scroll">
            <ul v-if="conversations.length > 0">
              <li v-for="conversation in sortedConversations" :key="conversation.id">
                <a 
                  href="#" 
                  :class="{ active: selectedConversation?.id === conversation.id }"
                  @click="selectConversation(conversation)"
                >
                  <i>
                    <img
                      src="@/assets/lems-v1/images/chat-project-6.png"
                      alt="Conversation Image" />
                  </i>
                  <strong>{{ getConversationDisplayName(conversation) }} <div class="conversation-date">{{ getLastMessagePreview(conversation) }}</div></strong>
                 
                </a>
                <!-- <div class="conversation-preview">
                  <small>{{ getLastMessagePreview(conversation) }}</small>
                </div> -->
              </li>
            </ul>
            <div v-else class="no-conversations">
              <p>No conversations found</p>
            </div>
          </div>
        </div>
        <button id="closeProject" class="close-row hide-desktop">
          {{ constants.CLOSE_BUTTON }}
        </button>
      </div>
      <div class="lmd-sm-7">
        <div class="lmd-chat-mdtop clearfix">
          <div class="lmd-chat-mdtop-l">
            <h2 v-if="selectedConversation">
              {{ getConversationDisplayName(selectedConversation) }}
              <span v-if="messages.length > 0">
                {{ messages.length }} messages
              </span>
            </h2>
            <h2 v-else>
              Select a conversation to start chatting
            </h2>
            
            <!-- Loading indicator for messages -->
            <!-- <div v-if="loading && selectedConversation" class="loading-messages">
              <p>Loading messages...</p>
            </div> -->
            
            <!-- Error state for messages -->
            <div v-if="error && selectedConversation" class="error-messages">
              <p style="color: red;">{{ error }}</p>
              <button @click="loadMessages(selectedConversation.token, false)" class="retry-btn">Retry</button>
            </div>
          </div>
          <!-- <div class="lmd-chat-mdtop-r">
            <div class="chat-hide-mobile chat-search">
              <input type="text" placeholder="" id="chatSearchInput" />
            </div>
            <div class="chat_link">
              <ul>
                <li>
                  <a
                    id="incomingOutgoingCallLink"
                    href="incoming-outgoing-call.html"
                    ><img
                      src="@/assets/lems-v1/images/video.svg"
                      alt="Chat Video Icon"
                  /></a>
                </li>
                <li>
                  <a
                    id="incomingOutgoingCallLink"
                    href="incoming-outgoing-call.html"
                    ><img
                      src="@/assets/lems-v1/images/audio.svg"
                      alt="Chat Audio Icon"
                  /></a>
                </li>
              </ul>
            </div>
          </div> -->
          <!-- <div class="clear"></div> -->
          <!-- <div class="chat-hide-desktop">
            <div class="chat-search">
              <input type="text" placeholder="" id="chatSearchInput" />
            </div>
          </div> -->
          <div class="chat-hide-desktop">
            <div class="pro-onlinelist-show">
              
              <div class="show-user-icon">
                <button id="showProject">
                  {{ constants.SELECT_USER_BUTTON }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="lmd-chat-mdbtm">
          <!-- Messages Container -->
          <div v-if="selectedConversation" class="chat-txt-box">
            <!-- No messages state -->
            <div v-if="!loading && sortedMessages.length === 0" class="no-messages">
              <p>No messages in this conversation yet.</p>
            </div>

            <!-- Scrollable Messages List -->
            <div
              ref="messagesContainer"
              class="messages-scroll"
              @scroll="onMessagesScroll"
            >
              <div v-for="message in sortedMessages" :key="message.id" class="message-container">
                <div v-if="!isSystemMessage(message)" :class="['chat-box', isOwnMessage(message) ? 'chat-box-right' : 'chat-box-left']">
                  <!-- <div class="chat-txt-setting">
                    <div class="c-t-s">
                      <img
                        src="@/assets/lems-v1/images/setting_dots.png"
                        alt="Image"
                      />
                    </div>
                  </div> -->

                  <div class="chat-box-mid">
                    <div class="right-chat-txt">
                      <div class="chat-txt-section preformatted" v-text="message.message">
                      </div>
                    </div>
                    <div class="chat-det">
                      <div class="chat-date">
                        {{ formatTimestamp(message.timestamp) }}
                      </div>
                      <div class="chat-user-name">{{ message.actorDisplayName }}</div>
                    </div>
                  </div>
                  <!-- <div class="chat-user-img">
                    <img
                      src="@/assets/lems-v1/images/team-members/team-member-1.jpg"
                      alt="User Avatar"
                    />
                  </div> -->
                </div>

                <!-- System messages -->
                <div v-else class="system-message">
                  <div class="system-message-content">
                    <span class="system-icon">🔔</span>
                    <span class="preformatted" v-text="message.message"></span>
                    <small>{{ formatTimestamp(message.timestamp) }}</small>
                  </div>
                </div>
              </div>

              <!-- Loading more indicator on top -->
              <div v-if="isLoadingMore" class="loading-messages">
                <p>Loading older messages...</p>
              </div>
            </div>
          </div>

          <!-- No conversation selected -->
          <div v-else class="no-conversation-selected">
            <p>Please select a conversation from the left panel to start chatting.</p>
          </div>
          <!-- Message Input Area -->
          <!-- <div v-if="selectedConversation" class="chat-typebox">
            <textarea 
              v-model="newMessage" 
              placeholder="Type your message here..."
              @keydown.enter.prevent="sendMessage"
              :disabled="loading"
            ></textarea>
            <div class="chat-attech">
              <div class="chat-uploadfile">
                <img src="@/assets/lems-v1/images/connect.svg" width="100%" />
              </div>
              <div class="chat-emozi">
                <img src="@/assets/lems-v1/images/emozi.svg" width="100%" />
              </div>
            </div>
            <button 
              @click="sendMessage" 
              :disabled="!newMessage.trim() || loading"
              class="send-button"
            >
              {{ loading ? 'Sending...' : 'Send' }}
            </button>
          </div> -->

          <!-- No conversation selected message -->
          <!-- <div v-else class="no-conversation-input">
            <p>Select a conversation to send messages</p>
          </div> -->
        </div>
      </div>
      <!--  <div id="chatright" class="lmd-sm-3">
        <button id="closeChat" class="close-row hide-desktop">
          {{ constants.CLOSE_BUTTON }}
        </button>
         <div class="lmdchat-user-box"> 
         <div class="lmdchat-user-search">
            <input type="text" placeholder="Search..." />
          </div>
          <div class="lmdchat-user-list" id="lmdchat-user-list">
            <ul>
              <li>
                <a href="employee-one-to-one-chat.html">
                  <div class="user-status user-status-active"></div>
                  <i>
                    <img
                      src="@/assets/lems-v1/images/team-members/team-member-2.jpg"
                      alt=""
                  /></i>
                  <strong>
                    Ashok Nagar
                    <b>
                      {{ constants.UI_DESIGNER_TEXT }}
                    </b>
                  </strong>
                  <span>20</span>
                </a>
              </li>
              <li>
                <a href="employee-one-to-one-chat.html">
                  <div class="user-status user-status-away"></div>
                  <i
                    ><img
                      src="@/assets/lems-v1/images/team-members/team-member-3.jpg"
                      alt="img"
                  /></i>
                  <strong>
                    Sashi Jangir
                    <b>
                      {{ constants.TECK_LEAD_TEXT }}
                    </b>
                  </strong>
                  <span>20</span>
                </a>
              </li>
              <li>
                <a href="employee-one-to-one-chat.html">
                  <div class="user-status user-status-busy"></div>
                  <i
                    ><img
                      src="@/assets/lems-v1/images/team-members/team-member-4.jpg"
                      alt="img"
                  /></i>
                  <strong>
                    Sumesh
                    <b>
                      {{ constants.BUSINESS_ANALYST_TEXT }}
                    </b>
                  </strong>
                  <span>20</span>
                </a>
              </li>
              <li>
                <a href="employee-one-to-one-chat.html">
                  <div class="user-status user-status-invisible"></div>
                  <i
                    ><img
                      src="@/assets/lems-v1/images/team-members/team-member-5.jpg"
                      alt="img"
                  /></i>
                  <strong>
                    Monika
                    <b>
                      {{ constants.BUSINESS_ANALYST_TEXT }}
                    </b>
                  </strong>
                  <span>20</span>
                </a>
              </li>
              <li>
                <a href="employee-one-to-one-chat.html">
                  <div class="user-status user-status-active"></div>
                  <i
                    ><img
                      src="@/assets/lems-v1/images/team-members/team-member-6.jpg"
                      alt="img"
                  /></i>
                  <strong>
                    Neha
                    <b>
                      {{ constants.BUSINESS_ANALYST_TEXT }}
                    </b>
                  </strong>
                  <span>20</span>
                </a>
              </li>
            </ul>
          </div> 
        </div> 
      </div>-->
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";
import axios from "axios";
import { API_BASE_URL } from "@/config/api.config";

interface NextcloudConversation {
  id: number;
  token: string;
  displayName: string;
  type: number;
  participantType: number;
  participantFlags: number;
  readOnly: number;
  hasPassword: boolean;
  hasCall: boolean;
  lastActivity: number;
  lastMessage?: {
    id: number;
    token: string;
    actorType: string;
    actorId: string;
    actorDisplayName: string;
    timestamp: number;
    message: string;
    messageType: string;
    systemMessage: string;
    messageParameters: any;
    expirationTimestamp: number;
    parentId: number;
    metaData: any;
  };
}

interface NextcloudMessage {
  id: number;
  token: string;
  actorType: string;
  actorId: string;
  actorDisplayName: string;
  timestamp: number;
  message: string;
  messageType: string;
  systemMessage: string;
  messageParameters: any;
  expirationTimestamp: number;
  parentId: number;
  metaData: any;
}

export default defineComponent({
  name: "EmployeeChats",
  data() {
    return {
      constants,
      // Nextcloud data
      conversations: [] as NextcloudConversation[],
      selectedConversation: null as NextcloudConversation | null,
      messages: [] as NextcloudMessage[],
      loading: false,
      error: null as string | null,
      // Current user info
      currentUser: null as any,
      // New message input
      newMessage: "",
      // API base URL
      apiBaseUrl: `${API_BASE_URL}/jira`,
      // Paging
      messageLimit: 50,
      isLoadingMore: false,
    };
  },
  async mounted() {
    await this.initializeChat();
  },
  computed: {
    sortedMessages(): NextcloudMessage[] {
      // Oldest at top, newest at bottom
      return [...this.messages].sort((a, b) => (a.timestamp || 0) - (b.timestamp || 0));
    },
    sortedConversations(): NextcloudConversation[] {
      // Newest (recent activity) at top, older at bottom
      return [...this.conversations].sort((a: any, b: any) => (b.lastActivity || 0) - (a.lastActivity || 0));
    }
  },
  methods: {
    async initializeChat() {
      try {
        // Check if user is logged in
        const isLoggedIn = localStorage.getItem("is_jira_loggedIn") === "true";
        const username = localStorage.getItem("jira_user_username");
        
        if (!isLoggedIn || !username) {
          this.error = "User not logged in";
          return;
        }
        
        // Create user object with username
        this.currentUser = {
          userName: username,
        };
        
        console.log("Initializing chat for user:", this.currentUser);
        await this.loadConversations();
      } catch (error) {
        console.error("Error initializing chat:", error);
        this.error = "Failed to initialize chat";
      }
    },

    async loadConversations() {
      if (!this.currentUser?.userName) {
        this.error = "User not found";
        return;
      }

      this.loading = true;
      this.error = null;

      try {
        console.log("Making API call to:", `${this.apiBaseUrl}/nextcloud/chat/${this.currentUser.userName}/`);
        const response = await axios.get(
          `${this.apiBaseUrl}/nextcloud/chat/${this.currentUser.userName}/`
        );

        console.log("API Response:", response.data);
        if (response.data.conversations) {
          this.conversations = response.data.conversations;
          console.log("Loaded conversations:", this.conversations);
        }
      } catch (error: any) {
        console.error("Error loading conversations:", error);
        console.error("Error response:", error.response?.data);
        this.error = error.response?.data?.error || "Failed to load conversations";
      } finally {
        this.loading = false;
      }
    },

    async selectConversation(conversation: NextcloudConversation) {
      this.selectedConversation = conversation;
      this.messageLimit = 50; // reset on room change
      await this.loadMessages(conversation.token, false);
      this.$nextTick(() => this.scrollToBottom());
    },

    async loadMessages(roomToken: string, keepPosition: boolean = false) {
      if (!this.currentUser?.userName) {
        this.error = "User not found";
        return;
      }

      if (keepPosition) {
        this.isLoadingMore = true;
      } else {
        this.loading = true;
      }
      this.error = null;

      const container = this.$refs.messagesContainer as HTMLElement | undefined;
      const prevScrollHeight = container ? container.scrollHeight : 0;
      const prevScrollTop = container ? container.scrollTop : 0;

      try {
        const response = await axios.get(
          `${this.apiBaseUrl}/nextcloud/chat/${this.currentUser.userName}/${roomToken}/messages/`,
          { params: { limit: this.messageLimit } }
        );

        if (response.data.messages) {
          this.messages = response.data.messages;
          console.log("Loaded messages:", this.messages.length);
          this.$nextTick(() => {
            if (keepPosition && container) {
              const newScrollHeight = container.scrollHeight;
              // Preserve viewport position after prepending older items
              container.scrollTop = newScrollHeight - (prevScrollHeight - prevScrollTop);
            }
          });
        }
      } catch (error: any) {
        console.error("Error loading messages:", error);
        this.error = error.response?.data?.error || "Failed to load messages";
      } finally {
        this.loading = false;
        this.isLoadingMore = false;
      }
    },

    async onMessagesScroll(event: Event) {
      const el = event.target as HTMLElement;
      if (!el || this.isLoadingMore || !this.selectedConversation) return;
      if (el.scrollTop <= 0) {
        // Reached top, load older messages by increasing limit
        this.messageLimit += 50;
        await this.loadMessages(this.selectedConversation.token, true);
      }
    },

    scrollToBottom() {
      const container = this.$refs.messagesContainer as HTMLElement | undefined;
      if (!container) return;
      container.scrollTop = container.scrollHeight;
    },

    async sendMessage() {
      if (!this.newMessage.trim() || !this.selectedConversation) {
        return;
      }

      if (!this.currentUser?.userName) {
        this.error = "User not found";
        return;
      }

      this.loading = true;
      this.error = null;

      try {
        const response = await axios.post(
          `${this.apiBaseUrl}/nextcloud/chat/${this.currentUser.userName}/${this.selectedConversation.token}/messages/`,
          {
            message: this.newMessage.trim()
          }
        );

        if (response.data.sent_message) {
          // Add the new message to the messages array
          this.messages.push(response.data.sent_message);
          this.newMessage = "";
          this.$nextTick(() => this.scrollToBottom());
          console.log("Message sent successfully");
        }
      } catch (error: any) {
        console.error("Error sending message:", error);
        this.error = error.response?.data?.error || "Failed to send message";
      } finally {
        this.loading = false;
      }
    },

    formatTimestamp(timestamp: number): string {
      const date = new Date(timestamp * 1000);
      const datePart = new Intl.DateTimeFormat('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      }).format(date);
      const timePart = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      }).format(date);
      return `${datePart} at ${timePart}`;
    },

    // formatMessage(message: string): string {
    //   // Basic HTML escaping for security
    //   return message
    //     .replace(/&/g, "&amp;")
    //     .replace(/</g, "&lt;")
    //     .replace(/>/g, "&gt;")
    //     .replace(/"/g, "&quot;")
    //     .replace(/'/g, "&#39;");
    // },

    getConversationDisplayName(conversation: NextcloudConversation): string {
      return conversation.displayName || `Room ${conversation.id}`;
    },

    getLastMessagePreview(conversation: NextcloudConversation): string {
      if (conversation.lastMessage) {
        return conversation.lastMessage.message.length > 50 
          ? conversation.lastMessage.message.substring(0, 50) + "..."
          : conversation.lastMessage.message;
      }
      return "No messages";
    },

    isSystemMessage(message: NextcloudMessage): boolean {
      return message.messageType === "system" || message.systemMessage !== "";
    },

    copyMessage(message: string) {
      navigator.clipboard.writeText(message).then(() => {
        console.log("Message copied to clipboard");
        // You could add a toast notification here
      }).catch(err => {
        console.error("Failed to copy message:", err);
      });
    },
    isOwnMessage(message: NextcloudMessage): boolean {
      const me = (this.currentUser?.userName || "").trim().toLowerCase();
      if (!me) return false;
      const actorId = (message.actorId || "").trim().toLowerCase();
      const actorName = (message.actorDisplayName || "").trim().toLowerCase();
      return actorId === me || actorName === me;
    },

    forwardMessage(message: NextcloudMessage) {
      // Implement forward functionality
      console.log("Forwarding message:", message);
      // You could open a modal or navigate to a forward page
    }
  },
});
</script>

<style scoped>
/* Loading and Error States */
.loading-state, .error-state {
  padding: 20px;
  text-align: center;
}

/* Scrollable conversations list */
.conversations-scroll {
  max-height: calc(100vh - 172px);
  overflow-y: auto;
  padding-right: 6px;
}

/* Scrollable messages area */
.messages-scroll {
  max-height: calc(100vh - 180px);
  overflow-y: auto;
  padding-right: 10px;
}

.preformatted {
  white-space: pre-wrap;
  word-break: break-word;
}

.retry-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
}

.retry-btn:hover {
  background: #0056b3;
}

/* Conversation List */
.conversation-preview {
  padding: 5px 10px;
  font-size: 12px;
  color: #666;
}

.no-conversations {
  padding: 20px;
  text-align: center;
  color: #666;
}

/* Messages */
.message-container {
  margin-bottom: 15px;
}

/* Left/Right aligned chat bubbles */
.chat-box {
  display: flex;
}
.chat-box-left {
  justify-content: flex-start;
}
.chat-box-right {
  justify-content: flex-end;
}
.chat-box-mid {
  max-width: 80%;
}
.chat-box-right .chat-box-mid {
  text-align: right;
}

.system-message {
  text-align: center;
  margin: 10px 0;
}

.system-message-content {
  background: #f8f9fa;
  padding: 10px;
  border-radius: 8px;
  display: inline-block;
  max-width: 80%;
}

.system-icon {
  margin-right: 5px;
}

.no-messages, .no-conversation-selected, .no-conversation-input {
  text-align: center;
  padding: 40px 20px;
  color: #666;
}

/* Message Input */
.send-button {
  background: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 10px;
}

.send-button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.send-button:hover:not(:disabled) {
  background: #0056b3;
}

/* Loading Messages */
.loading-messages, .error-messages {
  padding: 20px;
  text-align: center;
  color: #666;
}

.conversation-date{
  display: block;
  font-size: 11px;
  color: #999999;
}
.chatlmd-pro-list ul li a strong{
  width: 80%;
}
.chatlmd-pro-list ul li a.active:after{
  display: none;
}
.lmdchat-project-list h3{
  font-size: 13px;
}
@media (min-width: 1025px) and (max-width: 36000px) {
  .lmd-chat-section {
    .clearfix {
      display: flex;
    }
    .lmd-sm-2 {
      width: 280px;
      
    }
    .lmd-sm-7 {
      width: calc(100% - 280px);
     
    }
   
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .lmd-chat-section {
    .clearfix {
      display: flex;
    }
    .lmd-sm-2 {
      width: 240px;
    }
    .lmd-sm-7 {
      width: calc(100% - 240px);
     
    }
   
  }
}
@media (min-width:320px) and (max-width:767px) {
  .messages-scroll{ max-height: calc(100vh - 222px);}
  .conversations-scroll{max-height: calc(100vh - 195px);}
  .lmd-chat-section .lmd-sm-7{min-height: calc(100vh - 148px);}
}
</style>
